import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";

import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: ["modelValue", "placeholder"],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IconField), { iconPosition: "left" }, {
    default: _withCtx(() => [
      _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
      _createVNode(_unref(InputText), {
        modelValue: props.modelValue,
        placeholder: __props.placeholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _: 1
  }))
}
}

})